export default function OnboardingScreen3() {
  return (
    <div className="l2f-ob-screen">
      <div className="l2f-ob-eyebrow">03 · WHAT YOU GET</div>
      <h1 className="l2f-ob-headline">
        Verdict. Sizing. Nearby stores if you want to try it on.
      </h1>
      <p className="l2f-ob-body">
        A clear verdict, the size that fits you, and where to find it — online
        or on your street.
      </p>
      <div className="l2f-ob-visual" aria-hidden>
        <div className="l2f-ob-verdict-row">
          <span className="l2f-ob-pill l2f-ob-pill-buy">buy</span>
          <span className="l2f-ob-pill l2f-ob-pill-call">your call</span>
          <span className="l2f-ob-pill l2f-ob-pill-skip">skip</span>
        </div>
      </div>
    </div>
  );
}
